export default "__VITE_ASSET__BISBjfF2__"